/* eslint-disable @typescript-eslint/ban-types */
import { Col, Layout, Row, Space } from 'antd'
import { PropsWithChildren } from 'react'
import Loginbg from '../../static/img/loginbg.jpg'
import LogoHaup from '../../static/img/logo2.png'

export const HaupLayout = ({ children }: PropsWithChildren<{}>): JSX.Element => {
  return (
    <Layout
      style={{
        minHeight: '100vh',
        paddingBlock: '3rem',
        backgroundImage: `url(${Loginbg})`,
        backgroundSize: 'cover',
      }}
    >
      <Row justify="space-around" align="middle" style={{ minHeight: '100vh' }}>
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <Row style={{ minWidth: '100%' }} justify="center">
            <Col xs={24} sm={16} md={12} lg={8} xl={6} style={{ textAlign: 'center' }}>
              <img src={LogoHaup} height="40vh" />
            </Col>
          </Row>
          <Row style={{ minWidth: '100%' }} justify="center">
            <Col
              xs={24}
              sm={16}
              md={12}
              lg={8}
              xl={8}
              style={{ backgroundColor: 'white', textAlign: 'center', padding: '50px' }}
            >
              {children}
            </Col>
          </Row>
          <Row style={{ minWidth: '100%' }} justify="center">
            <Col
              xs={24}
              sm={16}
              md={12}
              lg={8}
              xl={6}
              style={{ textAlign: 'center', color: 'white' }}
            >
              <p>© {new Date().getFullYear()} Haupcar Company Limited.</p>
            </Col>
          </Row>
        </Space>
      </Row>
    </Layout>
  )
}
